export default {
    isMobile() {
        return $(window).width() < 768;
    },
    isTable() {
        return $(window).width() < 992;
    },
}

